// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1OLFH","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__kpSOn"};